import { preparePhone } from './phone';
import { ICreateConsultingRequestRequest } from '../../../repositories/newbuilding-flat-view-order/v1/create-consulting-request';
import { IRegion, IRequestFormValues } from '../../../types/requestForm';

export const prepareSubmitValues = (values: IRequestFormValues): ICreateConsultingRequestRequest => {
  return {
    phone: preparePhone(values.phone),
    regionId: (values.region as IRegion).id,
    requirements: values.requirements.trim() || undefined,
  };
};
